const recently_viewed_section = document.querySelector('.recently-viewed');
console.log("🚀 ~ file: recently-viewed.js:2 ~ recently_viewed_section:", recently_viewed_section)

const options = {
	rootMargin: '100px'
}

const observer = new IntersectionObserver(entry => {

    if (entry[0].isIntersecting == true) {

        observer.unobserve(recently_viewed_section);
    
        let rec_prods = localStorage.getItem('recentlyViewedProductHandles');
        if (rec_prods) {
            rec_prods_arr = rec_prods.replace("[","").replace("]","").split(',');
            
            let recently_viewed = document.querySelector('.recently-viewed-slider');
            
            rec_prods_arr.forEach((rec_prod, i) => {
                let index = i + 1;
                let handle = rec_prod.replace(/"/g,'');
                fetch(window.Shopify.routes.root + `products/${handle}?view=card&section_id=mm-recently-viewed-product-card`)
                  .then(response => {
                    if (response.ok) {
                      return response.text();
                    } else {
                      throw new Error("Error: " + response.status);
                    }
                  })
                  .then(data => {
                    const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                    const productCard = htmlDocument.documentElement.querySelector(".product-card");
                    let url = window.location.href + "#";
                    let swiper_slide = document.createElement("div");
                    swiper_slide.classList.add('swiper-slide');
                    swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);

                    if (productCard !== url) {
                      recently_viewed.insertAdjacentHTML('afterbegin', swiper_slide.outerHTML);
                    }

                    if ( ( index + 1 ) == rec_prods_arr.length  ) {
                      console.log('index: ', index, ' array len: ', rec_prods_arr.length )
                      const recent_swiper = new window.swiper('.recently-swiper', {
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                        breakpoints: {
                          350: {
                            spaceBetween: 30,
                            slidesPerView: 'auto',
                          },
                        },
                        pagination: {
                          el: '.swiper-pagination.recently-viewed-pagination',
                        },
  
                        on: {
                          afterInit: function () {
                            const rv_swiper_el = this.el;
                            rv_swiper_el.classList.remove('loading');
                            console.log('recent init: ', rv_swiper_el);
                          }
                        }
                      });
                    }
                  })
                  .catch(error => {
                    console.error(error);
                  });

            });
            
        } else {
            document.querySelector('.recently-viewed').style.display = 'none';
        }

        // Init section settings collection swiper
        const bestseller_swiper = new window.swiper('.recently-viewed-swiper', {
            slidesPerView: 1.1,
            spaceBetween: 15,
            breakpoints: {
              350: {
                spaceBetween: 30,
                slidesPerView: 'auto',
              },
            },
            pagination: {
              el: '.swiper-pagination.bestseller-pagination',
            },

            on: {
              afterInit: function () {
                const bs_swiper_el = this.el;
                bs_swiper_el.classList.remove('loading');
                console.log('bestseller init: ', bs_swiper_el);
              }
            }
            
        });
    }

        const tabs = recently_viewed_section.querySelectorAll('.tab');
        const contents = recently_viewed_section.querySelectorAll('.content');

        recently_viewed_section.addEventListener('click', (e) => {
            let target = e.target;

            if ( target.classList.contains('tab') ) {
                const selected_tab = target;
                if ( selected_tab.classList.contains('active') ) {
                    //console.log('target active');
                    return;
                } else {
                    const tab_index = selected_tab.getAttribute('data-tab-index');
                    //console.log('selected tab: ', selected_tab, 'tab index: ', tab_index );
                    
                    tabs.forEach( tab => {
                        if ( selected_tab != tab ) tab.classList.remove('active');
                        else tab.classList.add('active');
                    });
                    
                    contents.forEach( content => {
                        let content_index = content.getAttribute('data-tab-index');
                        //console.log('content: ', content, 'content index: ', content_index, 'tab index: ', tab_index);
                        if ( tab_index != content_index ) content.classList.remove('active');
                        else content.classList.add('active');
                    });
                }
    
            }
        });

  
}, options);

observer.observe(recently_viewed_section);